import { MapPin, Globe, ChevronDown } from 'lucide-react';

const CoveredDestinationsCard = ({
  destinationTab = 'domestic',
  setDestinationTab,
  featuredLocations = [],
  totalActiveLocationsCount = 0,
  onOpenModal,
}) => {
  return (
    <div className="bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-5 lg:p-6 border border-slate-100 shadow-sm flex-1 flex flex-col justify-between hover:shadow-md transition-all duration-300">
      <div>
        {/* Header */}
        <div className="flex flex-col gap-2.5 pb-2.5 border-b border-slate-100">
          <div>
            <h3 className="text-sm sm:text-base lg:text-lg font-normal text-slate-800 tracking-tight leading-snug">
              Where your travellers are covered
            </h3>
            <p className="text-[11px] sm:text-xs text-slate-500 mt-0.5 font-normal leading-tight">
              Domestic and international leisure hotspots.
            </p>
          </div>

          {/* Domestic vs International Toggle */}
          <div className="w-full">
            <div className="w-full grid grid-cols-2 p-0.5 sm:p-1 bg-slate-100/90 rounded-xl border border-slate-200/60 gap-1">
              <button
                type="button"
                onClick={() => setDestinationTab('domestic')}
                className={`w-full py-1 sm:py-1.5 rounded-lg text-xs font-medium transition-all flex items-center justify-center gap-1.5 cursor-pointer whitespace-nowrap ${
                  destinationTab === 'domestic'
                    ? 'bg-primary text-white shadow-2xs'
                    : 'text-slate-600 hover:text-slate-900'
                }`}
              >
                <MapPin
                  size={12}
                  className={destinationTab === 'domestic' ? 'text-white' : 'text-slate-400'}
                />
                <span>Domestic</span>
              </button>

              <button
                type="button"
                onClick={() => setDestinationTab('international')}
                className={`w-full py-1 sm:py-1.5 rounded-lg text-xs font-medium transition-all flex items-center justify-center gap-1.5 cursor-pointer whitespace-nowrap ${
                  destinationTab === 'international'
                    ? 'bg-primary text-white shadow-2xs'
                    : 'text-slate-600 hover:text-slate-900'
                }`}
              >
                <Globe
                  size={12}
                  className={destinationTab === 'international' ? 'text-white' : 'text-slate-400'}
                />
                <span>International</span>
              </button>
            </div>
          </div>
        </div>

        {/* Featured 12 Leisure Hotspots (3 rows of 4) */}
        <div className="mt-3.5">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            {featuredLocations.map((loc) => (
              <div
                key={loc}
                className="flex items-center justify-center gap-1.5 px-2.5 py-2 rounded-xl bg-slate-50/90 hover:bg-[#eaf8f7] border border-slate-200/70 hover:border-primary/40 text-xs font-medium text-slate-700 hover:text-primary transition-all duration-150 cursor-default shadow-2xs group"
              >
                <MapPin
                  size={11}
                  className="text-slate-400 group-hover:text-primary group-hover:scale-110 shrink-0 transition-all"
                />
                <span className="truncate">{loc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Card Action: View Full Directory */}
      <div className="mt-3.5 pt-2.5 border-t border-slate-100 flex items-center justify-between">
        <span className="text-[11px] font-normal text-slate-400">
          {totalActiveLocationsCount} leisure hotspots covered
        </span>
        <button
          type="button"
          onClick={onOpenModal}
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-medium text-primary hover:bg-[#eaf8f7] border border-transparent hover:border-[#c2ecea]/60 transition-all cursor-pointer active:scale-95"
        >
          <span>View all {totalActiveLocationsCount} locations</span>
          <ChevronDown size={13} />
        </button>
      </div>
    </div>
  );
};

export default CoveredDestinationsCard;
